import EventsAwardsDTALogoMenu from "@dta/components/EventsAwardsDTALogoMenu";
import EventsAwardsE50LogoMenu from "@e50/components/EventsAwardsE50LogoMenu";
import EventsAwardsEELogoMenu from "@ee/components/EventsAwardsEELogoMenu";
import { AwardType } from "@events-awards/utils/types";

export const EventsAwardsLayoutFactory = (awardType: AwardType) => {
  switch (awardType) {
    case AwardType.E50:
      return EventsAwardsE50LogoMenu;

    case AwardType.EE:
      return EventsAwardsEELogoMenu;

    case AwardType.DATA:
      return EventsAwardsDTALogoMenu;
  }
};
